import RequestForm from "@/pages/contact/RequestForm";
import { PARTNERSHIP_FORM } from "@/pages/contact/requestFormsContent";

export default function PartnershipRequest() {
  return <RequestForm spec={PARTNERSHIP_FORM} />;
}
